import {defineStore} from "pinia"

export const useUtilStore = defineStore("util", () => {

  const isMobile: Ref = ref<boolean>(true)

  const loading: Ref = ref(true)

  const upwards: Ref = ref(false)

  const hasSetEventLang: Ref = ref(false)

  const route = useRoute()

  const isSummaryPage: Ref = computed(() => route.path.endsWith('/summary'))
  const isDirectPage: Ref = computed(() => route.path.endsWith('/direct'))
  const isNavPinned: Ref = ref<boolean>(false)

  const exitModal: Ref = ref<ModalModel>({
    show: false,
    loading: false,
  })

  const shouldShowExitModal: Ref = computed(() => !isSummaryPage.value && !isDirectPage.value)

  return {
    hasSetEventLang,
    loading,
    isMobile,
    isSummaryPage,
    isDirectPage,
    isNavPinned,
    upwards,
    exitModal,
    shouldShowExitModal,
  }
});
